import React from 'react';
import './WorksHero.css';

const WorksHero = () => {
  return (
    <section className="works-hero">
      <div className="works-hero-overlay">
        <div className="works-hero-content">
          <h1>Works & Housing Department</h1>
          <p>Delivering roads, buildings, and public infrastructure that serve and connect communities.</p>
        </div>
      </div>
    </section>
  );
};

export default WorksHero;